export default __webpack_public_path__ + "static/media/img-food-service-selected.5d4f0c4e.svg";